import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const OuterWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  @media (min-width: 1256px) {
    overflow: unset;

    [data-testid='odds-grid'] & {
      overflow: hidden;
    }
  }
`;

export const scrollingClass = css`
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
`;

export const ScrollButton = styled.button`
  --oc-scroll-btn-size: 33;

  position: absolute;
  top: calc(50% - ((var(--oc-scroll-btn-size) / 2) * 1px));
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--oc-scroll-btn-size) * 1px);
  height: calc(var(--oc-scroll-btn-size) * 1px);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  transform: translateX(0) translateY(-1px);
  transition: transform 0.3s ease-in-out;

  &:after {
    content: '';
    left: -2px;
    width: 10px;
    height: 10px;
  }
`;

export const LeftButton = styled(ScrollButton)`
  left: 15px;

  &:after {
    border-top: 2px solid var(--oc-text-body);
    border-left: 2px solid var(--oc-text-body);
    transform: rotate(-45deg);
  }
`;

export const RightButton = styled(ScrollButton)`
  right: 15px;

  &:after {
    border-top: 2px solid var(--oc-text-body);
    border-right: 2px solid var(--oc-text-body);
    transform: rotate(45deg) translate(-2px, 1px);
  }
`;

export const buttonSlideOut = css`
  ${LeftButton}& {
    transform: translateX(-250px);
  }
  ${RightButton}& {
    transform: translateX(250px);
  }
`;

export const buttonHide = css`
  display: none;
`;
